export class CheckoutSdkProxy {
    listen(host, targetOrigin) {
        this.targetOrigin = targetOrigin;
        const listener = (event) => this.onMessage(event);
        host.addEventListener('message', listener);
        return () => host.removeEventListener('message', listener);
    }
    dispatchMessage(eventType, data) {
        if (!this.target) {
            throw new Error('Proxy target is required.');
        }
        const message = { eventType, data };
        this.target.postMessage(message, { targetOrigin: this.targetOrigin });
    }
    onMessage(event) {
        var _a;
        if (event.origin !== this.targetOrigin) {
            return;
        }
        if (!this.target) {
            this.target = (_a = event.source) !== null && _a !== void 0 ? _a : undefined;
        }
        this.onTargetMessage(event.data);
    }
}
//# sourceMappingURL=checkout-sdk-proxy.js.map